import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { orderDB } from "../../../shared/tables/order-list";
import { OrderService } from 'src/app/shared/service/order.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  public order = [];
  public temp = [];

  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;


  orderForms: { [key: number]: FormGroup } = {};
  statusOptions: any;



  constructor(public orderService: OrderService) {

    // this.order = orderDB.list_order;
    debugger

    this.orderService.getOrders("all").subscribe(data => {
      console.log("all orders:", data);
      this.order = data.result;
    }
    );


    this.orderService.getOrderStatus().subscribe(data => {
      console.log("order Status");
      console.log(data);
      this.statusOptions=data.result;
    });





  }


  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.order = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }



  // Fonction pour mettre à jour le statut
  updateStatus(row: any) {
    debugger
    console.log(`Order ${row.orderId} status updated to: ${row.statusId}`);
    // Ici, tu peux appeler ton API pour enregistrer la modification
    // Exemple avec HttpClient :
    // this.http.put(`api/orders/${row.orderId}/status`, { status: row.status }).subscribe();
    this.orderService.updateOrder(row.orderId,row.statusId);

  }

  onStatusChange(row: any, newStatus: number) {
    debugger
    row.statusId = newStatus;
    console.log(`Order ${row.orderId} status updated to: ${newStatus}`);
    this.updateStatus(row); // Call API here if needed
  }

  ngOnInit() {

    this.order.forEach(row => {
      this.orderForms[row.orderId] = new FormGroup({
        status: new FormControl(row.statusId)   // initialize with number
      });
    
      this.orderForms[row.orderId].get('status')?.valueChanges.subscribe(value => {
        row.statusId = +value;                  // ensure number
        this.updateStatus(row);
      });
    });
  }

}
